if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

function asyncVendorsLoad() {
  const scriptsToLoad = [
    {
      name: "vendor",
      src: getShopifyLink("vendor.js"),
    },
    // {
    //   name: "triplepixel",
    //   src: getShopifyLink("triplepixel.js"),
    // },
  ];

  const tag = document.getElementsByTagName("script")[0];
  scriptsToLoad.forEach((s) => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    // script.async = true;
    script.defer = true;
    script.src = s.src;

    script.addEventListener("load", (e) => {
      Shopify.vendors = Shopify.vendors || [];
      Shopify.vendors.push(s.name);
      document.dispatchEvent(new CustomEvent(`${s.name}.loaded`));
    });

    return tag.parentNode.insertBefore(script, tag);
  });
}

function getShopifyLink(fileName, location = "asset") {
  if (!Shopify.links) {
    return;
  }

  const baseLink = Shopify.links[location];

  return baseLink.replace("XXX.XXX", fileName);
}
